<template>
  <div class="pdfpage-footer" :style="'height: ' + height + 'px'">
    <el-divider content-position="center">{{page}}/{{total}}</el-divider>
    <div>
      <ol>
        <li>{{ $t('pdftxt.footercopyright1') }}</li>
        <li>{{ $t('pdftxt.footercopyright2') }}</li>
        <li>{{ $t('pdftxt.footercopyright3') }}</li>
      </ol>
    </div>
    <div class="pdfpage-footer-right">
      <p>{{ $t("pdftxt.updatetime") }}{{ update }}</p>
      <p>&copy; {{year}} simplyBrand</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReportFooter',
  props: ['update', 'year', 'page', 'total', "height"]
}
</script>